import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconOponents = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M26.5,16.6c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7C23.8,15.4,25,16.6,26.5,16.6z M26.5,12.3
		c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C24.9,13,25.7,12.3,26.5,12.3z"/>
        <path d="M26.5,17.1c-1.3,0-2.5,0.5-3.4,1.4c-0.9-0.9-2-1.6-3.2-1.9l0,0c-1.3-0.4-2.5-0.4-3.7,0l0.1,0.6l-0.1-0.6
		c-1.3,0.3-2.4,1-3.4,1.9c-0.9-0.9-2.1-1.3-3.3-1.3c-2.7,0-4.9,2.2-4.9,4.9c0,0,0,2.5,0,2.7l0,0.5h6.1c0,1.8,0,2.7,0,2.8l0,0.5h14.3
		l0-0.5c0,0,0-0.1,0-2.8h6.2l0-0.5c0-0.1,0-2.7,0-2.7C31.4,19.3,29.2,17.1,26.5,17.1z M5.7,22c0-2.1,1.7-3.7,3.7-3.7
		c1,0,1.9,0.4,2.6,1.1c-0.8,1.2-1.3,2.6-1.3,4.1l0,0.6h-5C5.7,23.4,5.7,22.2,5.7,22z M11.9,27.5c0-0.6,0-1.6,0-2.8l0-1.2
		c0-1.4,0.5-2.9,1.5-4c0.8-0.9,1.9-1.6,3.1-1.9l0,0c1.1-0.3,2.1-0.3,3.1,0l0.2-0.6l-0.2,0.6c1.2,0.3,2.3,1.1,3.1,2
		c0.9,1.1,1.3,2.4,1.3,3.8l0,1.7c0,1.1,0,1.8,0,2.3H11.9z M30.2,24.1h-5.1l0-0.6c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2
		c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2
		c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3
		c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0.7-0.7,1.6-1.1,2.6-1.1c2.1,0,3.7,1.7,3.7,3.7C30.3,22.2,30.3,23.4,30.2,24.1z"/>
        <path d="M18,15.2c2.2,0,3.9-1.8,3.9-3.9S20.1,7.4,18,7.4s-3.9,1.8-3.9,3.9S15.8,15.2,18,15.2z M18,8.5c1.5,0,2.7,1.2,2.7,2.7
		c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7C15.2,9.8,16.5,8.5,18,8.5z"/>
        <path d="M9.5,16.6c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7C6.7,15.4,8,16.6,9.5,16.6z M9.5,12.3
		c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6C7.9,13,8.6,12.3,9.5,12.3z"/>
      </g>
    </SvgIcon>
  );
};

IconOponents.displayName = 'IconOponents';
IconOponents.muiName = 'SvgIcon';

export default IconOponents;



// WEBPACK FOOTER //
// ./src/components/Icons/IconOpponents.js